import api from './index'

export default function addUtmTracking(id, values) {
  return api.post(`/api/utm/${id}`, values)
}
